import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { WhiteLabelService } from '@flexyoo/common';
import { EmployeeSelectedBenefit } from '@flexyoo/employee/models';
import { isNetSavingApplicable } from '@flexyoo/employee/util';
import { FlexyooNumberPipe } from '@flexyoo/shared/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { EmployeeFinancingPlanBadgeComponent } from '../employee-financing-plan-badge/employee-financing-plan-badge.component';

@Component({
  selector: 'flexyoo-employee-basket-benefit-row',
  templateUrl: './employee-basket-benefit-row.component.html',
  styleUrl: './employee-basket-benefit-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.background-color]': 'selectedBackgroundColor()',
    '(click)': 'onRowClick()',
  },
  imports: [
    TranslateModule,
    MatIconModule,
    MatTooltip,
    FlexyooNumberPipe,
    EmployeeFinancingPlanBadgeComponent,
  ],
})
export class EmployeeBasketBenefitRowComponent {
  protected readonly wls = inject(WhiteLabelService);

  readonly benefit = input.required<EmployeeSelectedBenefit>();
  readonly showRemoveButton = input<boolean>(false);
  readonly showConfirmIcon = input<boolean>(false);
  readonly showNetSavingColumn = input<boolean>(true);
  readonly isSelected = input<boolean>(false);

  readonly remove = output<void>();
  readonly sign = output<EmployeeSelectedBenefit>();

  protected readonly pbGrossAmount = computed(() => this.benefit().pbGrossAmount ?? 0);
  protected readonly ssGrossAmount = computed(() => this.benefit().ssPeriodBudget ?? 0);

  protected readonly selectedBackgroundColor = computed(() =>
    this.isSelected() ? 'var(--app-primary-25)' : null
  );

  protected readonly isConfirmDisabled = computed(() => this.benefit().isDisabledDueOrder);

  protected readonly showNetSavingAmount = computed(
    () => this.showNetSavingColumn() && isNetSavingApplicable(this.benefit())
  );

  protected readonly showNetSavingCell = computed(
    () =>
      this.showNetSavingColumn() ||
      this.showConfirmIcon() ||
      (this.showRemoveButton() && this.benefit().canRemove)
  );

  protected onRowClick(): void {
    this.sign.emit(this.benefit());
  }

  protected onRemoveClick(event: MouseEvent): void {
    event.stopPropagation();
    this.remove.emit();
  }
}
